// extracted by mini-css-extract-plugin
export default {"container":"CustomInput1_container__r1Pjx","icon":"CustomInput1_icon__2D326","blue":"CustomInput1_blue__FWjho","red":"CustomInput1_red__alZ6h","green":"CustomInput1_green__YZ37Q"};